import { action, observable } from 'mobx';
import { API_ACCOUNT_DETAIL_DEPOSIT_INSTRUCTIONS, API_ACCOUNT_DETAIL_EMPLOYER_PAYMENT } from 'api/endpoints';
import { FormStore } from '../formStore';
import { RootStore } from '../rootStore';
import { EmployerExt } from 'stores/workflowStores/finances/employers/model';
import { Currency } from 'enums';

interface DepositInstructions {
  variableSymbol: number;
  targetAccount: string;
  targetAccountEur: string;
  targetAccountEurIban: string;
  targetAccountEurSwift: string;
  sourceAccounts: { fullNumber: string, currency: Currency }[];
  qr: string;
  employers: EmployerExt[];
}

export class DepositMoneyStore extends FormStore<DepositInstructions> {
  @observable pdfLoading: { [key: string]: boolean } = {};

  constructor(rootStore: RootStore, accountId: string) {
    super(rootStore);
    this.rootStore = rootStore;
    this.accountId = accountId;
  }

  @action fetchDeposit = async (accountId?: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(API_ACCOUNT_DETAIL_DEPOSIT_INSTRUCTIONS(accountId || this.accountId));
    if (this.data?.employers) {
      this.data.employers.forEach((employer: EmployerExt) => {
        this.pdfLoading[employer.employer.companyNumber] = false;
      });
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  getEmployerPayment = async (companyNumber: string) => {
    this.pdfLoading[companyNumber] = true;
    await this.rootStore.stores.apiStore.get(API_ACCOUNT_DETAIL_EMPLOYER_PAYMENT(this.accountId, companyNumber));
    this.pdfLoading[companyNumber] = false;
  };
}
